import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import CardManagement from '@/views/CardManagement.vue'
import AgentManagement from '@/views/AgentManagement.vue'
import UserManagement from '@/views/UserManagement.vue'
import OnlineUsers from '@/views/OnlineUsers.vue'
import UserStats from '@/views/UserStats.vue'
import VerifyLogs from '@/views/VerifyLogs.vue'
import SystemLogs from '@/views/SystemLogs.vue'
import SystemSettings from '@/views/SystemSettings.vue'
import Overview from '@/views/Overview.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
    redirect: '/dashboard/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        meta: { requiresAuth: true }
      },
      {
        path: 'cards',
        name: 'CardManagement',
        component: CardManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'agents',
        name: 'AgentManagement',
        component: AgentManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'online-users',
        name: 'OnlineUsers',
        component: OnlineUsers,
        meta: { requiresAuth: true }
      },
      {
        path: 'user-stats',
        name: 'UserStats',
        component: UserStats,
        meta: { requiresAuth: true }
      },
      {
        path: 'verify-logs',
        name: 'VerifyLogs',
        component: VerifyLogs,
        meta: { requiresAuth: true }
      },
      {
        path: 'system-logs',
        name: 'SystemLogs',
        component: SystemLogs,
        meta: { requiresAuth: true }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: SystemSettings,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated']

  if (to.meta.requiresAuth && !isAuthenticated) {
    // 需要登录但未登录，跳转到登录页
    next('/login')
  } else if (to.meta.requiresGuest && isAuthenticated) {
    // 已登录用户访问登录页，跳转到首页
    next('/dashboard')
  } else {
    next()
  }
})

export default router